import { useEffect } from "react";

export default function Modal({ isOpen, onClose, label, className = "", children }) {
    useEffect(() => {
        if (!isOpen) return;

        const originalOverflow = document.body.style.overflow;
        const originalPaddingRight = document.body.style.paddingRight;

        const scrollbarWidth =
            window.innerWidth - document.documentElement.clientWidth;

        document.body.style.overflow = "hidden";
        document.body.style.paddingRight = `${scrollbarWidth}px`;

        return () => {
            document.body.style.overflow = originalOverflow;
            document.body.style.paddingRight = originalPaddingRight;
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4 md:p-8" onClick={onClose}>
            <div className="flex max-h-full min-h-0 w-full flex-col overflow-hidden rounded-sm bg-white md:w-fit" onClick={(event) => event.stopPropagation()}>
                {label && (
                    <header className="relative flex shrink-0 items-center justify-center border-b p-2 text-gray-500">
                        <h2 className="px-10 text-sm">{label}</h2>
                        <button type="button" onClick={onClose} className="absolute right-0 flex h-8 w-8 items-center justify-center">
                            ✕
                        </button>
                    </header>
                )}

                <div className={`min-h-0 overflow-y-auto ${className}`}>
                    {children}
                </div>
            </div>
        </div>
    );
}